// @flow
import React from 'react';
import { H3 } from '@finect/tabular-core/Headings';
import { Paragraph } from '@finect/tabular-core/Paragraph';
import { ArticleDetail, ArticleSide, SideBlockquote, Video, ArticleCTA } from '../../../components';

type Props = {
  staticContext?: Object,
  location: Object,
  history: Object,
  toggleModal: Function
};

export const Estudios = ({ location, history, toggleModal }: Props) => {
  const redirectTo = (url: string) => {
    history.push(url);
  };

  return (
    <ArticleDetail
      location={location}
      title="Cómo puede un asesor ayudarte a ahorrar para los estudios."
      redirectTo={redirectTo}
      toggleModal={toggleModal}
      mainVideo
    >
      <Paragraph>
        Una de las mayores preocupaciones de las familias es asegurarse de que sus hijos estudien en un buen colegio o
        en las mejores universidades. Y, si es posible, que hagan un master en el extranjero o en las escuelas de
        negocio más prestigiosas. El problema es… Que el coste puede ser muy alto y, por lo tanto, es imprescindible
        tener el dinero suficiente para cuando llegue el momento.
      </Paragraph>
      <Video
        inline
        id="dNEf_1yf7WM"
        src="https://www.youtube.com/embed/dNEf_1yf7WM?hd=1&showinfo=0&controls=0&rel=0&enablejsapi=1"
        caption="Luca Lazzarini, Banco Mediolanum."
      />
      <Paragraph>
        Por eso, conviene hacer cuánto antes una buena planificación financiera para ver cuánto necesitamos ahorrar y
        qué rentabilidad precisamos para lograr nuestros objetivos. Podemos intentar hacerlo por nuestra cuenta, pero
        contar con la ayuda de un asesor financiero nos ayudará a conseguir nuestro objetivo por estos motivos:
      </Paragraph>
      <H3>Calcular cuánto dinero necesitaremos</H3>
      <Paragraph>
        Lo primero que debemos saber es cuánto dinero necesitaremos para poder pagar los estudios a nuestros hijos. La
        estimación inicial parece sencilla, pero lo normal es que nos quedemos cortos. No sólo hay que tener en cuenta
        el precio estimado de los estudios, sino los gastos de material escolar, el alojamiento... También el
        desplazamiento, tanto de los hijos como de los padres para visitarles a lo largo del curso escolar o para la
        graduación.
      </Paragraph>
      <ArticleSide position="right">
        <SideBlockquote>
          No sólo hay que pensar en la matrícula, sino en otros gastos de la etapa universitaria o del master, como
          desplazamientos, alojamiento, materiales de estudio...
        </SideBlockquote>
      </ArticleSide>
      <H3>Domesticar la inflación</H3>
      <Paragraph>
        Los precios de las matrículas universitarias y de los posgrados hoy no son los mismos que hace 20 años… Ni de
        los alquileres para vivir cerca del campus. Si, además, no conseguimos rentabilidad por nuestro dinero, entramos
        en un círculo vicioso: cada vez nos cuesta más ahorrar mientras nuestro dinero cada vez ‘compra’ menos cosas. El
        efecto de la inflación puede ser letal y dejar insuficientes nuestros ahorros. Un buen asesor nos ayudará a
        calcular cómo afectará la inflación y qué debemos hacer para contrarrestarla.
      </Paragraph>
      <H3>Cuánta rentabilidad necesitamos</H3>
      <Paragraph>
        50.000 euros para la matrícula de la escuela de negocios, 10.000 para alojamientos, 2.000 para material de
        estudio, 2.000 para desplazamientos… Supongamos que nos sale 80.000 euros para el master dentro de 10 años, que
        sumándole la inflación se nos acerca a los 100.000 euros en cifras redondas. ¿Cuánto necesitaremos ahorrar al
        mes? ¿Qué rentabilidad debemos obtener para asegurarnos el objetivo? ¿Qué riesgo podemos asumir? Las respuestas
        te las dará un buen asesor, tras conocer bien tu situación financiera y familiar.
      </Paragraph>
      <ArticleCTA toggleModal={toggleModal} />
      <H3>Puesta en marcha y seguimiento</H3>
      <Paragraph>
        No sólo se trata de hacer el plan, sino de ejecutarlo. Nuestro asesor se encargará de ir guiándonos en todo el
        proceso y ayudarnos a cumplir los plazos que nos hemos marcado y no dejarnos llevar por la pereza en los asuntos
        financieros. También, del control de la evolución del planteamiento y la conveniencia de revisarlo, si es
        necesario.
      </Paragraph>
      <Paragraph>
        En resumen, contar con un buen asesor puede ser clave para ayudarte a conseguir uno de los grandes objetivos de
        las familias: dar la mejor formación a nuestros hijos. Cuanto más tiempo pase sin hacer un plan y ponerlo en
        marcha, más difícil lo tendremos. Mejor empezar cuanto antes.
      </Paragraph>
    </ArticleDetail>
  );
};
